import React, { useEffect, useState } from 'react';
import ResponsiveContainer from 'components/layout/PageComponents';
import { Row, LeftCell, RightCell } from 'components/layout/Misc';
import {Sidebar, Icon} from 'semantic-ui-react'
import {NavItem, SideNav, SidebarWrapper, NavList, IconLink, IconContent} from 'components/RightSideBar'


import data1 from '../config/charts/ead.json'

import {
    Grid,
    Header,
    List,
    Segment,
    Dropdown,
    Input,
    Label
  } from 'semantic-ui-react';

import { BarChart, Bar, Text, Cell, CellLocalString, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import population from 'config/charts/population';

Array.prototype.stableSort = function(cmp) {
    cmp = !!cmp ? cmp : (a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    };
    let stabilizedThis = this.map((el, index) => [el, index]);
    let stableCmp = (a, b) => {
      let order = cmp(a[0], b[0]);
      if (order != 0) return order;
      return a[1] - b[1];
    }
    stabilizedThis.sort(stableCmp);
    for (let i=0; i<this.length; i++) {
      this[i] = stabilizedThis[i][0];
    }
    return this;
  }

const stateSizes = {
  'Johor': 19166,
  'Kedah': 9492,
  'Kelantan': 15040,
  'Melaka': 1712,
  'Negeri Sembilan': 6658,
  'Pahang': 35965,
  'Pulau Pinang': 1049,
  'Perak': 21146,
  'Perlis': 819,
  'Selangor': 7951,
  'Trengganu': 12958,
  'National': 131598,
}


const data = data1.filter(x => x.source != 'sw')
  .map(x => {
    let source = x['source'];
    let small_source = x['source']
    if (source == 'f') source = 'Fluvial'
    if (source == 'c') source = 'Coastal'
    if (source == 'sw') source = 'Surface Water'
    let state = x['state'];
    let keys = Object.keys(x).filter(k => k != 'state').filter(k => k != 'source');
    
    return keys.map(k => {
        let int_name = small_source + '_' + k
        let parts = int_name.split('_')
        let pop = parts[5]
        if (pop == 'nopop') pop = 'No pop growth'

        let epoch = parts[2]
        if (epoch == 'pd') epoch = 'Present Day'
        
        return {
            name: small_source + '_' + k,
            int_name: small_source + '_' + k,
            source: source,
            state: state,
            epoch: epoch,
            ead: x[k],
            climate: parts[3],
            population: pop,
            defense: parts[4].charAt(0).toUpperCase() + parts[4].slice(1),
            USD: x[k],
            USDkm2: x[k] / stateSizes[state],
            MYR: x[k] * 1/.2,
            MYRkm2: (x[k] * 1/.2) / stateSizes[state] 
        }})
}).flat()


const epochs = ['All', 'Present Day', '2030s', '2070s']
// const sources = ['All', 'Coastal', 'Fluvial', 'Surface Water'] 
const sources = ['All', 'Coastal', 'Fluvial'] 
const popGrowths = ['All', 'No pop growth', 'SSP2','SSP4']
const defenses = ['All', 'Undefended', 'Maintain', 'Enhance', 'Reduced']
const climates = ['All', 'RCP45', 'RCP85']
const states = ['All states', 'National',
 'Johor', 'Kedah', 'Kelantan', 'Melaka', 'Negeri Sembilan', 'Pahang', 'Perak', 'Perlis', 'Pulau Pinang', 'Selangor', 'Trengganu']
const currencies = ['USD', 'USD/km2', 'MYR', 'MYR/km2']

const renderLegend = (props) => {
    const { payload } = props;
    return (
        <ul>
        {
            payload.map((entry, index) => (
            <li key={`item-${index}`}>{entry.value}</li>
            ))
        }
        </ul>
    );
}


const YAxisTickFormatter = (number) => {
    if(number > 1000000000){
      return (number/1000000000).toString() + 'B';
    }else if(number > 1000000){
      return (number/1000000).toString() + 'M';
    }else if(number > 1000){
      return (number/1000).toString() + 'K';
    }else{
      return number.toString();
    }
  }

  const ToolTipNumberFormatter = (number) => {
    if(number > 1000000000){
      return (Math.round(number/100000000)/10).toString() + 'B';
    }else if (number > 1000000){
      return (Math.round(number/100000) / 10).toString() + 'M';
    }else if(number > 1000){
      return Math.round(number/1000).toString() + 'K';
    }else{
      return Math.round(number.toString());
    }
  }

  const CustomXAxisTick = ({ x, y, payload }) => {
    if (payload && payload.value) {
      return (
        <Text
            angle={-90}
            fontSize={"12px"}
            width={800}
            height={500}
            x={x} 
            y={y} 
            textAnchor="end" 
            verticalAnchor="middle"
        >{payload.value}</Text>
      );
    }
    return null;
};

const stateOptions = states.map(e=> {return {key: e, text: e, value: e}})
const sourceOptions = sources.map(e => {return {key: e, text: e, value: e}})
const epochOptions = epochs.map(e => {return {key: e, text: e, value: e}})
const climateOptions = climates.map(e => {return {key: e, text: e, value: e}})
const defneseOptions = defenses.map(e => {return {key: e, text: e, value: e}})
const popGrowthOptions = popGrowths.map(e => {return {key: e, text: e, value: e}})
const currencyOptions = currencies.map(e => {return {key: e, text: e, value: e}})

const getFillColor = (dp) => {

    const scheme = {
        'Fluvial': {
            'Present Day': '#bfe3bf',
            '2030s': '#7fc97f',
            '2070s': '#307330'
        },
        'Coastal': {
            'Present Day': '#ded6e9',
            '2030s': '#beaed4',
            '2070s': '#5b427e'
        },
        'Surface Water': {
            'Present Day': '#fedfc2',
            '2030s': '#fdc086',
            '2070s': '#be5e03'
        },
        
    }
    
    return scheme[dp.source][dp.epoch]
}


const InfoComponent = () => {
  return (<SidebarWrapper style={{padding: '5px'}}>
    <h5>Standards of protenction</h5>
    <p><b>Enhance</b></p>
    <table>
      <tr>
        <th style={{textAlign: 'left'}}>Landuse</th>
        <th style={{textAlign: 'left'}}>S</th>
        <th style={{textAlign: 'left'}}>F</th>
        <th style={{textAlign: 'left'}}>C</th>
      </tr>

      <tr><td>Agriculture (non-paddy)</td>       <td>0</td>   <td>20</td>     <td>20</td></tr>
      <tr><td>Agriculture (paddy)</td>           <td>0</td>   <td>0</td>      <td>0</td></tr>
      <tr><td>Rural Residential</td>             <td>10</td>  <td>60</td>     <td>60</td></tr>
      <tr><td>Urban Residential</td>             <td>10</td>  <td>60</td>     <td>60</td></tr>
      <tr><td>Commercial and Institutional</td>  <td>10</td>  <td>60</td>     <td>60</td></tr>
      <tr><td>Industrial and Infrastructure</td> <td>10</td>  <td>60</td>     <td>60</td></tr>
      <tr><td>Roads</td>                         <td>10</td>  <td>30</td>     <td>30</td></tr>
      <tr><td>Others</td>                        <td>0</td>   <td>0</td>      <td>0</td></tr>
      <tr><td>Urban</td>                         <td>30</td>  <td>100</td>    <td>150</td></tr>
    </table>


    <p><b>Maintain</b></p>
    <table>
      <tr>
        <th style={{textAlign: 'left'}}>Landuse</th>
        <th style={{textAlign: 'left'}}>S</th>
        <th style={{textAlign: 'left'}}>F</th>
        <th style={{textAlign: 'left'}}>C</th>
      </tr>

      <tr><td>Agriculture (non-paddy)</td>       <td>0</td>   <td>10</td>     <td>10</td></tr>
      <tr><td>Agriculture (paddy)</td>           <td>0</td>   <td>0</td>      <td>0</td></tr>
      <tr><td>Rural Residential</td>             <td>5</td>   <td>40</td>     <td>30</td></tr>
      <tr><td>Urban Residential</td>             <td>5</td>   <td>40</td>     <td>30</td></tr>
      <tr><td>Commercial and Institutional</td>  <td>5</td>   <td>40</td>     <td>30</td></tr>
      <tr><td>Industrial and Infrastructure</td> <td>5</td>   <td>40</td>     <td>30</td></tr>
      <tr><td>Roads</td>                         <td>5</td>   <td>15</td>     <td>15</td></tr>
      <tr><td>Others</td>                        <td>0</td>   <td>0</td>      <td>0</td></tr>
      <tr><td>Urban</td>                         <td>20</td>  <td>75</td>     <td>100</td></tr>
    </table>


    <p><b>Reduced</b></p>
    <table>
      <tr>
        <th style={{textAlign: 'left'}}>Landuse</th>
        <th style={{textAlign: 'left'}}>S</th>
        <th style={{textAlign: 'left'}}>F</th>
        <th style={{textAlign: 'left'}}>C</th>
      </tr>

      <tr><td>Agriculture (non-paddy)</td>       <td>0</td>     <td>5</td>      <td>5</td></tr>
      <tr><td>Agriculture (paddy)</td>           <td>0</td>     <td>0</td>      <td>0</td></tr>
      <tr><td>Rural Residential</td>             <td>2.5</td>   <td>20</td>     <td>20</td></tr>
      <tr><td>Urban Residential</td>             <td>2.5</td>   <td>20</td>     <td>20</td></tr>
      <tr><td>Commercial and Institutional</td>  <td>2.5</td>   <td>20</td>     <td>20</td></tr>
      <tr><td>Industrial and Infrastructure</td> <td>2.5</td>   <td>20</td>     <td>20</td></tr>
      <tr><td>Roads</td>                         <td>2.5</td>   <td>5</td>      <td>5</td></tr>
      <tr><td>Others</td>                        <td>0</td>     <td>0</td>      <td>0</td></tr>
      <tr><td>Urban</td>                         <td>10</td>    <td>50</td>     <td>75</td></tr>
    </table>
  </SidebarWrapper>)
}

const SideBarCompenent = () => {

  const [sidebarContent, setSidebarVisible] = React.useState(false)

  return (
    <React.Fragment>
      <Sidebar
        visible={!!sidebarContent}
        onHide={() => setSidebarVisible(false)}
        vertical='true'
        direction='right'
        animation='overlay'
        width='wide'
        style={{background: 'white', zIndex: 9999}}
      >
        <SidebarWrapper>
          {sidebarContent === 'info' && <InfoComponent /> }
        </SidebarWrapper>
      </Sidebar>

      <SideNav width={1} style={{paddingTop: '104px'}}>
      <NavList>

        <NavItem>
          <IconLink onClick={() => setSidebarVisible('info')}>
            <IconContent>
              <span><Icon name='info' size='big' /></span>
              <span style={{display: 'block'}}>
              Info
                </span>
            </IconContent>
          </IconLink>
        </NavItem>

      </NavList>
      </SideNav>
    </React.Fragment>
  )
}

export default (props) => {
  const [filteredData, setFilteredData] = useState(data)

  const [source, setSource] = useState(sources[0])
  const [epoch, setEpoch] = useState(epochs[0])
  const [popGrowth, setPopGrowth] = useState(popGrowths[0])
  const [defense, setDefense] = useState(defenses[0])
  const [climate, setClimate] = useState(climates[0])
  const [state, setState] = useState(states[0])
  const [numBars, setNumBars] = useState(null)
  const [legend, setLegend] = useState([])

  const [currency, setCurrency] = useState('USD')
  let currencySymbol
  switch (currency) {
    case 'USD':
    case 'USD/km2': currencySymbol = '$'; break;

    case 'MYR':
    case 'MYR/km2': currencySymbol = 'MYR'
  }

  function CustomTooltip({ payload, label, active }) {
    if (active && payload && payload.length) {

      // get value with M / B suffix 
      let value = ToolTipNumberFormatter(payload[0].value) 
      return (
        <div className="custom-tooltip">
          <p className="label">{`${label} : ${currencySymbol} ${value.toLocaleString('en-US')}`}</p>
        </div>
      );
    }
  
    return null;
  }


  useEffect(() => {
    const filteringData = data.filter(data => {
            if (source !== sources[0] && data.source !== source)
                return false

            if (epoch !== epochs[0] && data.epoch !== epoch)
                return false

            if (popGrowth !== popGrowths[0] && data.population !== popGrowth)
                return false

            if (defense !== defenses[0] && data.defense !== defense) {
                if (data.epoch !== 'Present Day' || data.defense !== 'Maintain') {
                    return false
                }
            }
            if (defense === 'Undefended') {
              if (data.defense !== 'Undefended') return false
            }

            if (climate !== climates[0] && data.climate !== climate && data.climate !== 'RCPNone')
                return false

            if (state !== states[0] && data.state !== state) 
                return false

            if (state === states[0] && data.state === 'National')
                return false

            return true
            
        }).map(val => {
            let name = []

            if (state == states[0]) {
                name.push(val.state)
            }

            if (epoch == epochs[0]) {
                name.push(val.epoch)
            }
            if (source == sources[0]) {
                name.push(val.source)
            }
            if (defense == defenses[0]) 
                name.push(val.defense)

            if (val.epoch !== 'Present Day') {
                if (climate === climates[0] && val.climate !== null) 
                    name.push(val.climate)

                if (popGrowth === popGrowths[0])
                    name.push(val.population)
            }

            val.name = name.join(' - ')
            val.fill = getFillColor(val)
            return val
        })
        .stableSort((a,b) => {
          if (a.defense === b.defense) return 0
      
          if (a.defense === 'Undefended') return -1
          if (b.defense === 'Undefended') return 1
      
          if (a.defense === 'Reduced') return -1
          if (a.defense === 'Enhance') return 1
          if (b.defense === 'Reduced') return 1
          return -1
      })
      
      .stableSort((a,b) => {
          if (a.population === b.population) return 0
      
          if (a.population == 'No pop growth') {
              return -1
          }
      
          if (a.population == 'SSP4') {
              return 1
          }
          if (b.population == 'No pop growth') return 1
          return -1
      })
      
      .stableSort((a,b) => {
          if (a.climate === b.climate) return 0
      
          if (a.climate == 'RCPNone') return -1
          if (a.climate == 'RCP85') return 1
      
          if (b.climate == 'RCPNone') return 1
          return -1
      })
      


      .stableSort((a, b) => {
          if (a.epoch === b.epoch) return 0
      
          if (a.epoch == '2070s') {
              return 1
          }
          if (a.epoch == 'Present Day') {
              return -1
          }
      
          // a = 2030s
          if (b.epoch == 'Present Day') return 1
          return -1
      })

      .stableSort((a,b) => {
        if (a.state === b.state) return 0;
      
        if (a.state === 'National') return -1; 
      
        return a.state.localeCompare(b.state);
      })
      

      .stableSort((a,b) => {
        if (a.source === b.source) return 0
    
        if (a.source === 'Coastal') {
            return -1
        }
        if (a.source === 'Fluvial') {
            return 1
        }
        // a SW
        if (b.source === 'Coastal') return 1;
        return -1;
    })

  
    setFilteredData(filteringData)

  }, [data, state, source, epoch, climate, defense, popGrowth])

  useEffect(() => {
    const legendEntries = []
    if (source === sources[0] && epoch === epochs[0]) {
        sources.slice(1).forEach(source => {
            epochs.slice(1).forEach(epoch => {
                legendEntries.push({
                    dataKey: 'currencyEad',
                    type: 'rect',
                    color: getFillColor({source, epoch}),
                    value: `${source} - ${epoch}`
                })
            })
        })
    }

    else if (source === sources[0]) {
        sources.slice(1).forEach(source => {
            legendEntries.push({
                dataKey: 'currencyEad',
                type: 'rect',
                color: getFillColor({source, epoch}),
                value: `${source}`
            })
        })
    }

    else if (epoch === epochs[0]) {
        epochs.slice(1).forEach(epoch => {
            legendEntries.push({
                dataKey: 'currencyEad',
                type: 'rect',
                color: getFillColor({source, epoch}),
                value: `${epoch}`
            })
        })
    }

    else {
        legendEntries.push({
            dataKey: 'currencyEad',
            type: 'rect',
            color: getFillColor({source, epoch}),
            value: `Expected Annual Damage (${currencySymbol})`
        })
    }


    setLegend(legendEntries)
  }, [source, epoch])

  const lineLength = filteredData.map(dp => dp.name ? dp.name.length : 0)
  .reduce((max_length, length, i) => length > max_length ? length : max_length, 0)

  const legendHeight = 10 + Math.ceil((lineLength / 10) * 61);

  return (
    <ResponsiveContainer height={100} currentPage="charts">
      <Segment style={{ padding: '3em 0em' }} vertical>
        <Grid container stackable verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column width={8}>
              <Header as='h2' style={{ fontSize: '2em' }}>
                Charts
              </Header>
            </Grid.Column>
            <Grid.Column width={8}>
            </Grid.Column>
          </Grid.Row>


          <Grid.Row>
            <Grid.Column width={4}>
                <Row>
            <span className="flex-container align-middle" style={{width: "180px"}}>State:</span> 
            <span><Dropdown
                label="state"
                selection
                onChange={(evt, selector) => {
                    setState(selector.value)
                }}
                options={stateOptions}
                value={state}
                /></span>
                </Row>

            </Grid.Column>

            <Grid.Column width={4}>
                <Row>
            <span className="flex-container align-middle" style={{width: "180px"}}>Source:</span> 
            <Dropdown
                label="test"
                selection
                onChange={(evt, selector) => {
                    setSource(selector.value)
                }}
                options={sourceOptions}
                value={source}
                />
                </Row>
            </Grid.Column>

            <Grid.Column width={4}>
              <Row>
                <span className="flex-container align-middle" style={{width: "180px"}}>Epoch:</span> 
                <Dropdown
                label="epoch"
                selection
                onChange={(evt, selector) => {
                    setEpoch(selector.value)
                }}
                options={epochOptions}
                value={epoch}
                />
              </Row>
            </Grid.Column>

            <Grid.Column width={4}>
              <Row>
                <span className="flex-container align-middle" style={{width: "180px"}}>Climate:</span>: 
            <Dropdown
                label="climate"
                selection
                onChange={(evt, selector) => {
                    setClimate(selector.value)
                }}
                options={climateOptions}
                value={climate}
                />
              </Row>
            </Grid.Column>


            <Grid.Column width={4}>
              <Row>
                <span className="flex-container align-middle" style={{width: "180px"}}>Adaptation standards:</span>
            <Dropdown
                label="Adaptation standards"
                selection
                onChange={(evt, selector) => {
                    setDefense(selector.value)
                }}
                options={defneseOptions}
                value={defense}
                />
              </Row>
            </Grid.Column>

            <Grid.Column width={4}>
              <Row>
                <span className="flex-container align-middle" style={{width: "180px"}}>Population:</span>
            <Dropdown
                label="pop_growth"
                selection
                onChange={(evt, selector) => {
                    setPopGrowth(selector.value)
                }}
                options={popGrowthOptions}
                value={popGrowth}
                />
              </Row>
            </Grid.Column>

            <Grid.Column width={4}>
              <Row>
                <span className="flex-container align-middle" style={{width: "180px"}}>Currency:</span>
            <Dropdown
                label="currency"
                selection
                onChange={(evt, selector) => {
                    setCurrency(selector.value)
                }}
                options={currencyOptions}
                value={currency}
                />
              </Row>
            </Grid.Column>


          </Grid.Row>
          <Grid.Row>

                <BarChart
                    width={1100}
                    height={500 + legendHeight }
                    data={filteredData}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 50,
                    }}
                >
                <CartesianGrid strokeDasharray="3 3" />

                <XAxis tick={<CustomXAxisTick angle={-30}/>} height={legendHeight} angle={-90} dataKey="name" />  
                

                <YAxis label={{ value: `Expected Annual Damages (${currency})`, angle: -90, offset: 9, position: 'left' }} tickFormatter={YAxisTickFormatter}/>
                <Tooltip content={<CustomTooltip />}/>
                <Legend payload={legend} />
                <Bar dataKey={currency.replace('/', '')} />
                </BarChart>


          </Grid.Row>
        </Grid>

      </Segment>
      <SideBarCompenent />

    </ResponsiveContainer>  
  )
}